define('webshopQuotationsView',[
  'module',
  'app',
  'marionette',
  'underscore',
  'modalsAlertView',
  'webshopQuotationsListView',
  'webshopQuotationsDetailView',
  'entities/webshop/quotations',
  'template!webshopQuotationsView'
], function (
  Module,
  App,
  Marionette,
  _,
  AlertView,
  ListView,
  DetailView,
  QuotationsApi,
  Tpl
) {
  'use strict';

  // Webshop > Quotations: the quotes generated from the webshop product pages
  // (webshop cws_product_quotations), searched server side, newest first.
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-quotations-view',

    pageSize: 50,

    regions: {
      listRegion: '.list-region',
      detailRegion: '.detail-region'
    },

    ui: {
      search: 'input.search',
      from: 'input.from',
      to: 'input.to',
      domain: 'select.domain',
      total: '.total'
    },

    events: {
      'input @ui.search': 'onSearch',
      'change @ui.from': 'fetch',
      'change @ui.to': 'fetch',
      'change @ui.domain': 'fetch'
    },

    initialize: function (options) {
      this.items = [];
      this.total = 0;
      this.domains = null;
      this.requestId = 0;
      this.selectedId = options.quotationId ? parseInt(options.quotationId, 10) : null;
    },

    onShow: function () {
      this.listView = new ListView();
      this.listView.on('select', _.bind(this.showQuotation, this));
      this.listView.on('more', _.bind(this.fetchMore, this));
      this.getRegion('listRegion').show(this.listView);

      if (this.selectedId)
        this.showQuotation(this.selectedId);

      this.fetch();
    },

    params: function (first) {
      return {
        query: this.ui.search.val().trim(),
        from: this.ui.from.val(),
        to: this.ui.to.val(),
        domain: this.ui.domain.val(),
        first: first,
        pageSize: this.pageSize
      };
    },

    fetch: function () {
      var requestId = ++this.requestId;

      this.listView.setLoading(true);

      QuotationsApi.search(this.params(0)).done(_.bind(function (result) {
        // an older search answering late must not replace the current one
        if (this.isDestroyed || requestId !== this.requestId)
          return;
        this.items = result.items;
        this.total = result.total;
        this.setDomains(result.domains);
        this.refreshList();
      }, this)).fail(_.bind(function (message) {
        if (!this.isDestroyed)
          this.listView.setLoading(false);
        AlertView.prototype.open('', message);
      }, this));
    },

    fetchMore: function () {
      var requestId = this.requestId;

      this.listView.setLoading(true);

      QuotationsApi.search(this.params(this.items.length)).done(_.bind(function (result) {
        if (this.isDestroyed || requestId !== this.requestId)
          return;
        this.items = this.items.concat(result.items);
        this.total = result.total;
        this.refreshList();
      }, this)).fail(_.bind(function (message) {
        if (!this.isDestroyed)
          this.listView.setLoading(false);
        AlertView.prototype.open('', message);
      }, this));
    },

    refreshList: function () {
      this.ui.total.text(this.total + ' ' + _.i18n('webshop.quotations.quotations', null, 'quotation(s)'));
      this.listView.setItems(this.items, this.total, this.selectedId);
    },

    setDomains: function (domains) {
      if (this.domains)
        return;
      this.domains = domains || [];
      _.each(this.domains, function (domain) {
        this.ui.domain.append($('<option/>').val(domain).text('.' + domain));
      }, this);
    },

    onSearch: function () {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(_.bind(this.fetch, this), 300);
    },

    showQuotation: function (id) {
      this.selectedId = id;
      this.listView.setSelected(id);
      App.navigate('webshop/quotations/' + id, {trigger: false});
      this.getRegion('detailRegion').show(new DetailView({quotationId: id}));
    },

    onDestroy: function () {
      clearTimeout(this.searchTimer);
    }
  });
});

